import React, { FC } from 'react'

import { IconPhotosProps } from './IconPhotos.types'
import * as Styled from './styles/IconPhotos.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPhotos: FC<IconPhotosProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPhotosProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPhotosProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M160 129.17V24a24 24 0 0 0-24-24H24A24 24 0 0 0 0 24v112a24 24 0 0 0 24 24h112a24 24 0 0 0 24-24v-6.83zM24 8h112a16 16 0 0 1 16 16v95.51l-37.88-37.87a4 4 0 0 0-5.66 0L93.41 96.69 47.06 50.35a4 4 0 0 0-6.26.77L8 105.8V24A16 16 0 0 1 24 8zm112 144H24a16 16 0 0 1-16-16v-14.65l37-61.72 45.56 45.55a4 4 0 0 0 5.66 0l15.05-15.05 40.73 40.7V136a16 16 0 0 1-16 16z' />
        <path d='M120 56.5A16.5 16.5 0 1 0 103.5 40 16.52 16.52 0 0 0 120 56.5zm0-25a8.5 8.5 0 1 1-8.5 8.5 8.51 8.51 0 0 1 8.5-8.5z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPhotos
